// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w6xc","newExpiryDate":"styles_newExpiryDate__2XS9v","footer":"styles_footer__3OFGj"};